/** Hand a text file to the browser's download mechanism. */
export function downloadTextFile(filename: string, content: string, mimeType: string): void {
  const url = URL.createObjectURL(new Blob([content], { type: mimeType }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.append(link);
  link.click();
  link.remove();
  // The download has started once click() returns; releasing the URL later keeps slow browsers safe.
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}

const REVOKE_DELAY_MS = 10_000;

export const MimeType = {
  Json: 'application/json',
  Csv: 'text/csv;charset=utf-8',
} as const;

/** Excel reads UTF-8 CSV with Chinese text correctly only when the file starts with a byte order mark. */
export const CSV_BYTE_ORDER_MARK = '﻿';
